import React, { useEffect, useState } from 'react'
import { Grid,Typography,Theme,Divider,Button} from '@mui/material'
import { createStyles, makeStyles } from "@mui/styles";
import { useStore } from 'store/StoreProvider';
import useFilteredProviders from 'hooks/useFiltereProviders';
import { confirmedAPT } from 'assets/icons/base64Icons';
import moment from 'moment';
import { useSession } from 'hooks/SessionProvider';
import { getAppointments } from 'services/apiService';
import Errorview from '../aptForm/components/form/ErrorView';
import { ErrorMessages } from 'utils/constants';
import PhoneIcon from '@mui/icons-material/Phone';
import { BackendDateFormat , customRoutes} from 'utils/constants';
import { useRoute } from 'hooks/RouteProvider';


const useStyles = makeStyles((theme:Theme) =>
    createStyles({
        successIconMain:{
           width:"100%",
           display:"flex",
           justifyContent:"center"
        }
        
    })
  );

function SuccessAPT() {
  const classes = useStyles();
  const store = useStore();
  const data=store.getData();
  const APTDetails=store.getAPTDetails()
  const  DRDetails =useFilteredProviders(data?.Providers,APTDetails?.appointment?.doctor_id)
  const  DRAddresses =useFilteredProviders(data?.Addresses,APTDetails?.appointment?.address_id)
  const getAppointmentType = (id: number): any => {
    return data?.AppointmentTypes.find((appt: { id: number; }) => appt.id === id) || "";
  }
  const {setIsDateTimeSelected,setAptCreated}=useSession();
  const APTTime = moment.parseZone(APTDetails.appointment?.appointment_time,BackendDateFormat).format('hh:mm A');
  const APTDate = moment.parseZone(APTDetails.appointment?.appointment_time).format('dddd, MMMM D, YYYY');
  const APTLocation=`${DRAddresses?.address_line_one}, ${DRAddresses?.city}, ${DRAddresses?.state}, ${DRAddresses?.zip_code}`
  const APTType=getAppointmentType(APTDetails?.appointment?.appointment_type_id)
  const[isError,setIsError]=useState<any>(null)
  const[loading,setIsLoading]=useState<boolean>(false)
  const websiteLink=data?.BusinessDetails?.website_link;
  const { navigate } = useRoute()
  const otherBooking=()=>{
    store.clearSelectedDateTime();
    setAptCreated(false);
    store.clearAPTDetails();
    setIsDateTimeSelected(false);
    navigate(customRoutes.APTDetails)
    }

    useEffect(()=>{
        window.scrollTo({ top: 0, behavior: 'smooth' }); // auto scroll bottom to top on small height screens
    },[])


    useEffect(()=>{
       const getUpdatedAPPT=async ()=>{
        setIsLoading(true)
        try {
            const result = await getAppointments(`${data.BaseUrl}${data.DataEndpoint}`);
            
            if(result)
            {
                store.setData({...data,FilterdSchedules: result});
                setIsLoading(false)
            } 
          } catch (error) {
            console.error('Error:', error);
            setIsError(error)
          }
         }
       
         getUpdatedAPPT();

    },[store])

    const cleanPhoneNumber = (phone:string) => {
        return phone.replace(/\D/g, '');
      };
  return (
    <Grid>
        {!isError?
        (
        <Grid>
            <Grid className={classes.successIconMain}>
                <img src={confirmedAPT}  width={300} alt="" />
            </Grid>
            <Grid className={classes.successIconMain}>
                <Typography variant='body2' sx={{fontSize:"20px",fontWeight:"300",color:"#747487",textAlign:"center"}}>{`${APTDetails?.patient?.first_name}, you are confirmed!`}</Typography>
            </Grid>

            <Grid sx={{textAlign:"center", display:"flex",justifyContent:"center",marginTop:"10px"}}>
                <Divider
                    orientation="vertical"
                    flexItem
                    sx={{  height: '0.5px !important', backgroundColor: 'grey',  width:"25%"}}
                />
            </Grid>


            <Grid className={classes.successIconMain} sx={{marginTop:"10px"}}>
                <Grid >
                    <Typography variant='body2' sx={{ fontSize: '15px', display: 'flex', alignItems: 'center',fontWeight:"400", color:"#747487" }}>
                        {APTDate}      
                    </Typography>
                </Grid> 
            </Grid> 

            <Grid container className={classes.successIconMain} sx={{ marginTop: '10px' }}>
                <Grid item>
                    <Typography variant="body2" sx={{ fontSize: '19px', display: 'flex', alignItems: 'center' }}>
                    {APTTime}
                    </Typography>
                </Grid>
            </Grid>

            <Grid container className={classes.successIconMain} sx={{ marginTop: '10px' }}>
                <Grid item>
                    <Typography variant="body2" sx={{ fontSize: '19px', display: 'flex', alignItems: 'center' }}>
                    {`${DRDetails?.first_name} ${DRDetails?.last_name}`}
                    </Typography>
                </Grid>
            </Grid>

            <Grid className={classes.successIconMain} sx={{marginTop:"10px"}}>
                <Grid >
                    <Typography variant='body2' sx={{ fontSize: '15px', display: 'flex', alignItems: 'center',fontWeight:"400", color:"#747487" }}>
                        {APTType?.name}      
                    </Typography>
                </Grid> 
            </Grid> 
            
            <Grid className={classes.successIconMain} sx={{marginTop:"10px"}}>
                <Grid >
                    <Typography variant='body2' sx={{ fontSize: '15px', display: 'flex', alignItems: 'center',fontWeight:"400", color:"#747487",textAlign:"center"}}>
                        {APTLocation}      
                    </Typography>
                </Grid> 
            </Grid>  
            
            <Grid className={classes.successIconMain} sx={{marginTop:"10px"}}>
                <Grid >
                    <Typography variant='body2' sx={{ fontSize: '15px', display: 'flex', alignItems: 'center',fontWeight:"400", color:"#747487",textAlign:"center"}}>
                    <PhoneIcon></PhoneIcon>
                    <a href={`tel:${cleanPhoneNumber(data?.BusinessDetails?.primary_phone)}`} style={{ marginLeft: '4px', marginRight: '4px', color:"#1976d2" }}>
                    {data?.BusinessDetails?.primary_phone}
                    </a>   
                    </Typography>
                </Grid> 
            </Grid>
            
             <Grid className={classes.successIconMain} sx={{marginTop:"10px"}}>
                <Grid >
                <Typography
                    variant='body2'
                    sx={{
                    fontSize: '15px',
                    display: 'flex',
                    alignItems: 'center',
                    fontWeight: "400",
                    color: "#747487",
                    textAlign: "center"
                    }}
                    >
                    {` Visit Our Website:`}
                   
                    <a href={` https://${websiteLink}`} 
                     target="_blank" 
                     rel="noopener noreferrer" 
                     style={{ marginLeft: '4px', marginRight: '4px' , color:"#1976d2" }}>
                   {websiteLink}
                    </a>
                    </Typography>

                </Grid> 
            </Grid>
            
                <Grid className={classes.successIconMain} sx={{marginTop:"20px",marginBottom:"20px"}}>
                <Grid >
                    <Button variant='outlined' onClick={otherBooking}>Book A New Appointment</Button>
                </Grid> 
            </Grid>
        </Grid>
        ):
        loading &&
        (<Errorview errorMessage={ErrorMessages.faildToGetAPT} setError={setIsError} setLoading={setIsLoading}></Errorview>)
        }
    </Grid>
  )
}

export default SuccessAPT